/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {service as UnitService} from "../../../Services/UnitService";
import {FormControl} from "react-bootstrap";
import React from "react";

export class UnitFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props);

		this.setInitialState({
			units: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		UnitService.Get()
			.then((x) => {
				this.setState({units: x.result});
			});
	}

	@autobind
	_render() {
		const {units} = this.state || {};
		const {Value, OnUpdate} = this?.props;

		return <FormControl
			as="select"
			placeholder="Select A Unit"
			value={Value || ""}
			onChange={x => OnUpdate?.(x.target.value)}
		>
			<option value="">Select A Unit</option>
			{
				units?.map(unit =>
					<option value={unit?.unitId} key={unit?.unitId}>
						{unit?.name}
					</option>
				)
			}
		</FormControl>;
	}
}